import { Box, Stack, Typography } from "@mui/material";

const EmptyState = ({ icon, title, description, sx }) => (
  <Stack spacing={1.5} alignItems="center" sx={{ py: 2, ...sx }}>
    <Box
      sx={{
        width: 72,
        height: 72,
        borderRadius: "50%",
        display: "grid",
        placeItems: "center",
        bgcolor: "rgba(25,118,210,0.12)",
        color: "primary.main",
      }}
    >
      <Box sx={{ fontSize: 34, display: "flex" }}>{icon}</Box>
    </Box>

    <Typography variant="subtitle1" sx={{ fontWeight: 700, textAlign: "center" }}>
      {title}
    </Typography>

    {description ? (
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ textAlign: "center", maxWidth: 380 }}
      >
        {description}
      </Typography>
    ) : null}
  </Stack>
);

export { EmptyState };
